import moment from "moment";
import {playerDepartment} from "./scoutingData";
import {playerReportsAverage} from "./scoutingReports";
export const dsCandidateDepartment = (player) =>
	({P: "gk", D: "def", C: "mid", A: "att"})[playerDepartment(player)] || null;
export const dsReportsForPlayer = (reports, id) =>
	(reports || [])
		.filter((r) => r.playerId === id)
		.sort(
			(a, b) =>
				(b.reportDate || "").localeCompare(a.reportDate || "") ||
				(b.creationDate || "").localeCompare(a.creationDate || "") ||
				a.id.localeCompare(b.id),
		);
export const dsPlayerScoutingSummary = (snapshot, id) => {
	const reports = dsReportsForPlayer(snapshot?.scoutingReports, id);
	const visions = (snapshot?.scoutingVisions || []).flatMap((v) =>
		(v.rows || [])
			.filter((r) => r.playerId === id)
			.map((r) => ({
				...r,
				visionId: v.id,
				matchId: v.matchId,
				observer: v.observer,
				match: v.match,
			})),
	);
	return {
		reports,
		average: playerReportsAverage(reports),
		last: reports[0] || null,
		visions,
	};
};
export const dsUpcomingObservations = (rows, now = moment(), days = 14) =>
	rows.filter((m) => {
		if (!m.startDate || !moment(m.startDate).isValid()) return false;
		const date = moment(m.startDate),
			end = now.clone().startOf("day").add(days, "days");
		return (
			(m.startTimeToBeConfirmed
				? date.isSameOrAfter(now, "day")
				: date.isAfter(now)) && date.isBefore(end)
		);
	});
export const dsProviderSeason = (season) => {
	if (!season?.startDate || !moment(season.startDate).isValid()) return null;
	const date = moment(season.startDate),
		year = date.month() >= 6 ? date.year() : date.year() - 1;
	return year + "/" + String((year + 1) % 100).padStart(2, "0");
};
